import { ReactComponent as AccountIcon } from '../../res/icon/locPin.svg';
import {useDispatch} from "react-redux";
import {login} from "../../redux/action/authActions";

const OrgSelectCard = ({org, onOrgSelected}) => {

    return (
        <div className="bp-select-card" style={{gridTemplateRows: "1fr 0"}} onClick={() => onOrgSelected(org.id)}>
            <AccountIcon />
            <p style={{margin: "auto 0", height: "auto", fontWeight: "500", color: "var(--secondary)"}}>{org.name}</p>
        </div>
    )

}

const OrgSelect = ({orgs, authToken}) => {

    const dispatch = useDispatch();

    const onOrgSelected = (orgID) => {
        dispatch(login({orgID: orgID, authToken: authToken}))
    }

    return (
        <div className="bp-select">
            <p><span>Please select a Location:</span></p>
            <div className="bp-select-options">
                {orgs.map(org =>
                    <OrgSelectCard org={org} onOrgSelected={onOrgSelected} />
                )}
            </div>
        </div>
    )

}

export default OrgSelect;